<nav
  class="navbar navbar-expand-md navbar-light"
  style="background: rgba(241, 241, 241, 0.9);"
  *ngIf="isAuth"
>
  <div
    class="navbar-collapse collapse w-100 order-1 order-md-0 dual-collapse2"
    align="center"
    data-toggle="collapse"
    data-target=".navbar-collapse.show"
  >
    <ul class="navbar-nav mr-auto">
      <li routerLinkActive="active" class="nav-item" *ngIf="isAuth">
        <a class="nav-link" [routerLink]="['/nowPlaying']"
          ><img src="../../assets/play-circle.svg" /> Playing</a
        >
      </li>
      <li class="nav-item" routerLinkActive="active" *ngIf="isAuth">
        <a class="nav-link" [routerLink]="['/search']"
          ><img src="../../assets/search.svg" /> Search
        </a>
      </li>
      <li class="nav-item" routerLinkActive="active" *ngIf="isAuth">
        <a class="nav-link" [routerLink]="['/playlist']"
          ><img src="../../assets/list.svg" /> Playlist
        </a>
      </li>
    </ul>
  </div>
  <div class="mx-auto order-0">
    <a class="navbar-brand mx-auto" routerLink=""
      ><img src="../../assets/logo4.png" alt="" height="60px"
    /></a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target=".dual-collapse2"
      id="toggler"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>
  <div
    class="navbar-collapse collapse w-100 order-3 dual-collapse2"
    align="center"
    data-toggle="collapse"
    data-target=".navbar-collapse.show"
  >
    <ul class="navbar-nav ml-auto">
      <li class="nav-item" routerLinkActive *ngIf="isAuth">
        <a class="nav-link" [routerLink]="['/favorites']">
          Favorites <img src="../../assets/heart.svg"
        /></a>
      </li>
      <li class="nav-item" routerLinkActive="active" *ngIf="isAuth">
        <a class="nav-link" [routerLink]="['/add']"
          >New Song <img src="../../assets/plus-square.svg"
        /></a>
      </li>
      <li class="nav-item" *ngIf="!isAuth">
        <a class="nav-link" routerLink="/auth"
          >Login <img src="../../assets/log-in (1).svg"
        /></a>
      </li>
      <li class="nav-item" *ngIf="isAuth">
        <a class="nav-link" style="cursor: pointer;" (click)="onLogout()"
          >Logout <img src="../../assets/log-out.svg"
        /></a>
      </li>
    </ul>
  </div>
</nav>
